import ImagePlaceholder from "@/components/base/ImagePlaceholder";

const checks = [
  "Dépose de la sangle, du cordon ou de la manivelle existante",
  "Mesure du poids et des dimensions du tablier pour choisir le moteur",
  "Installation du moteur tubulaire Somfy dans l'axe du volet",
  "Raccordement électrique sur prise proche ou filin dissimulé",
  "Pose des supports de fin de course et réglage de la course",
  "Programmation des commandes io, RTS ou interrupteur mural",
];

export default function ManuelVersElectrique() {
  return (
    <section className="bg-white py-14 md:py-20">
      <div className="max-w-7xl mx-auto px-4 md:px-8">
        <div className="grid grid-cols-1 lg:grid-cols-2 gap-8 lg:gap-12 items-center">
          <div className="order-2 lg:order-1">
            <h2 className="text-brand-blue text-2xl md:text-3xl font-extrabold mb-5">
              Passer du manuel à l'électrique avec Somfy
            </h2>
            <p className="text-brand-text text-base leading-relaxed mb-5">
              L'électrification d'un volet roulant manuel consiste à transformer votre installation existante en volet motorisé sans changer le tablier ni le coffre. Nos techniciens interviennent à Strasbourg et dans le Bas-Rhin pour retirer l'organe de manœuvre manuel — sangle, cordon ou manivelle — et installer un moteur tubulaire Somfy directement dans l'axe du volet. Nous choisissons le moteur en fonction du poids de votre tablier, de sa largeur et du type de lames pour garantir une motorisation fluide et durable.
            </p>
            <p className="text-brand-text text-base leading-relaxed mb-6">
              Une fois le moteur installé, nous réalisons le raccordement électrique. Si une prise de courant est disponible à proximité du coffre, l'installation est simple et rapide. Dans le cas contraire, nous proposons une solution de filin dissimulé ou une petite extension électrique. Nous programmons ensuite les commandes selon vos besoins : télécommande Somfy io ou RTS, interrupteur mural, ou même intégration dans votre système domotique. Chaque électrification est testée et réglée avant notre départ.
            </p>
            <ul className="space-y-3 mb-8">
              {checks.map((check) => (
                <li key={check} className="flex items-start gap-3">
                  <span className="w-6 h-6 flex items-center justify-center rounded-full bg-brand-cyan/10 shrink-0 mt-0.5">
                    <i className="ri-check-line text-brand-cyan text-sm"></i>
                  </span>
                  <span className="text-brand-text text-base">{check}</span>
                </li>
              ))}
            </ul>

            <a
              href="tel:0374473240"
              className="flex items-center justify-center gap-2 bg-brand-cyan text-white px-6 py-4 rounded-full font-semibold text-base hover:bg-brand-cyan/90 transition-all duration-200 btn-hover-effect whitespace-nowrap mx-auto"
            >
              <span className="btn-icon-wrap"><i className="ri-phone-line text-lg"></i></span>
              Appeler le 03 74 47 32 40
            </a>
          </div>

          <div className="order-1 lg:order-2 relative rounded-xl overflow-hidden border border-brand-border">
            <ImagePlaceholder src="https://static.readdy.ai/image/60b7a1bdc124301cce40c5bb19c672c9/0b90d177024cc0fa994b50be9825e961.jpeg" alt="Avant après électrification volet roulant manuel en Somfy" className="w-full h-[340px] md:h-[420px]" loading="lazy" />
          </div>
        </div>
      </div>
    </section>
  );
}